// extracted by mini-css-extract-plugin
module.exports = {"root":"_2e3f28","footNote":"_a55a2f"};